import { render, staticRenderFns } from "./webAIagent.vue?vue&type=template&id=7801b00c&scoped=true&"
import script from "./webAIagent.vue?vue&type=script&lang=js&"
export * from "./webAIagent.vue?vue&type=script&lang=js&"
import style0 from "./webAIagent.vue?vue&type=style&index=0&id=7801b00c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7801b00c",
  null
  
)

export default component.exports